import "./Faq.css";

function Faq() {
  return (
    <>
      <div className="Faq">
        <h1>Mother's Day FAQ & Gifting Tips</h1>
        <h3>FAQ</h3>
        <h4>When is Mother's Day 2022?</h4>
        <p>Mother's Day 2022 is Sunday, May 8, in the United States.</p>

        <h4>What is Mother’s Day?</h4>
        <p>
          Mother's Day is the celebration of mothers and motherhood. It became
          an official U.S. holiday in 1914, and since then it's become a day to
          honor not only your own mother, but your grandmother, stepmother,
          mother-in-law, sister, aunt, girlfriend, wife, best friend or anyone
          else you choose to celebrate.
        </p>

        <h4>Who celebrates Mother’s Day?</h4>
        <p>
          Anyone can celebrate Mother's Day! Whether you're honoring a mother
          you know/knew, motherhood in general or the influence of mothers on
          the world, you can celebrate this holiday. And there are so many ways
          to show your appreciation—thoughtful gifts, spending time
          together...whatever feels right for you.
        </p>

        <h4>What are good gifts for Mother’s Day?</h4>
        <p>
          Some of our most popular gifts for Mother's Day include{" "}
          <a href="">handbags</a>,<a href="">jewelry</a>,
          <a href="">home decor</a>,<a href="">picture frames</a>,
          <a href="">personalized gifts</a>, kitchenware, tech gadgets,
          gardening accessories, UGG® slippers and self-care products. Every mom
          has her own unique interests, which is why we have a variety of
          options to help you find the perfect gifts for the mom(s) in your
          life.
        </p>

        <h4>What are some great last-minute Mother's Day gift ideas?</h4>
        <p>
          Don't worry, you can still find the best last-minute gifts for mom
          online and in stores. We offer a free ship-to-store option so you can
          shop online and safely pick up your order from your local U.S.
          Nordstrom Rack or U.S. Nordstrom store (great for anyone with limited
          time and/or to ensure that your gift is a complete surprise!). Our
          stores are also full of great gift options for every mom. Of course,
          if you believe "mother knows best", an eGift card or Gift Card is the
          perfect way to make her day!
        </p>
        <br />

        <h2>Tips on How to Find the Perfect Mother's Day Gift</h2>
        <p style={{ marginTop: "-15px" }}>
          Finding a gift as unique as your mom isn't as hard as you think. Start
          by thinking about the following:
        </p>

        <div>
          <p>
            <b>1. What are her hobbies? </b>Gardening? Sewing? Reading? Catching
            up with her friends? Hobbies are a great way to find just the right
            gift. Even if you don't know what books she's reading now, a new
            lamp, cozy throw or earbuds for when she's listening to the
            audiobook version are great ways to show you know her interests.
          </p>
          <p>
            <b>2. What's her style?</b> Does she enjoy getting out and staying
            active? Love a bit of sparkle? Commit to matching her handbags to
            her outfits? Accessories are always a smart option here if you don't
            know her size, and you can find them for every kind of look.
          </p>

          <p>
            <b>3. What do you enjoy doing together?</b> Making a meal? Watching
            movies? Just hanging out and wearing beauty masks together? If it's
            cooking, new cookware and gadgets are excellent options (and food
            storage containers if she likes to send you home with leftovers!).
            Want a sentimental gift that celebrates your relationship? A photo
            frame is perfect...just add a photo of the two of you together that
            you love and she's sure to love it too.
          </p>
          <p>
            Okay, you're ready to start shopping for the perfect Mother's Day
            gift! This is a gift for someone who means something to you, so make
            sure your gift is meaningful. Whether it's a small gift or something
            you need to buy an extra-big bow for, if it makes her smile, it's
            the right gift. Have fun, and have a happy Mother's Day!
          </p>
          <br />
        </div>
      </div>
    </>
  );
}
export default Faq;